import React from 'react';
import {Container, Row, Col} from 'reactstrap';
import About from "../../../assets/images/Project/table.png";
import {useTranslation} from 'react-i18next';
import {appConfig} from '../../../config';

const Features = () => {
    const {t} = useTranslation();

    return (
        <React.Fragment>
            <section className="section">
                <Container>
                    <Row className="align-items-center justify-content-lg-between justify-content-center gy-4">
                        <Col lg={5} sm={7}>
                            <div
                                className="about-img-section mb-5 mb-lg-0 text-center animate__animated animate__fadeInLeft animate__delay-2s">
                                <img src={About} alt="" className="img-fluid mx-auto rounded-3"/>
                            </div>
                        </Col>
                        <Col lg={7} sm={5} className='ps-5'>
                            <div className="text-muted">
                                <h2 className="mb-3 lh-base text-capitalize">
                                    {t('t-schedule-how-works-head').replace('{appName}', appConfig.appName)}
                                </h2>
                                <p className="ff-secondary fs-16 mb-2">
                                    {t('t-schedule-how-works-desc')}
                                </p>

                                <div className="vstack gap-2 mb-4 pb-1">
                                    <div className="d-flex align-items-center">
                                        <div className="flex-shrink-0 me-2">
                                            <div className="avatar-xs icon-effect">
                                                <div
                                                    className="avatar-title bg-transparent text-success rounded-circle h2">
                                                    <i className="ri-check-fill"></i>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="flex-grow-1">
                                            <p className="mb-0">
                                                {t('t-schedule-how-works1').split('{appName}')[0]}
                                                <span className='fw-semibold'>{appConfig.appName}</span>
                                                {t('t-schedule-how-works1').split('{appName}')[1]}
                                            </p>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center">
                                        <div className="flex-shrink-0 me-2">
                                            <div className="avatar-xs icon-effect">
                                                <div
                                                    className="avatar-title bg-transparent text-success rounded-circle h2">
                                                    <i className="ri-check-fill"></i>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="flex-grow-1">
                                            <p className="mb-0">
                                                {t('t-schedule-how-works2')}
                                            </p>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center">
                                        <div className="flex-shrink-0 me-2">
                                            <div className="avatar-xs icon-effect">
                                                <div
                                                    className="avatar-title bg-transparent text-success rounded-circle h2">
                                                    <i className="ri-check-fill"></i>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="flex-grow-1">
                                            <p className="mb-0">{t('t-schedule-how-works3')}</p>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center">
                                        <div className="flex-shrink-0 me-2">
                                            <div className="avatar-xs icon-effect">
                                                <div
                                                    className="avatar-title bg-transparent text-success rounded-circle h2">
                                                    <i className="ri-check-fill"></i>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="flex-grow-1">
                                            <p className="mb-0">{t('t-schedule-how-works4')}</p>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center">
                                        <div className="flex-shrink-0 me-2">
                                            <div className="avatar-xs icon-effect">
                                                <div
                                                    className="avatar-title bg-transparent text-success rounded-circle h2">
                                                    <i className="ri-check-fill"></i>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="flex-grow-1">
                                            <p className="mb-0">{t('t-schedule-how-works5')}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </React.Fragment>
    );
}

export default Features;